import React from "react";
import DeviceError from "./pages/Device/DeviceError";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error(error);
    return { hasError: true, error: "error !!!" };
  }

  componentDidCatch(error, errorInfo) {
    // FIXME: add sentry
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <DeviceError error={this.state.error} />;
    }

    return this.props.children;
  }
}
